const MEASUREMENT_DATA = {
  sizeGuideTitle: {
    titleKey: 'PDP_SIZE_GUIDE_LABEL',
    default: 'Size Guide',
  },
  measurementTitle: {
    titleKey: 'PDP__PRODUCT_MEASUREMENTS',
    default: 'View how to measure and international sizing',
  },
  resizeDataText: {
    titleKey: 'PDP_INFOMATION_RESIZE',
    default:
      'We’re going through an adjustment period, you may notice the label doesn’t match the size you order. Please choose the size according to the measurement guide.',
  },
}

const BODY_PART_MEASUREMENT = {
  accent_width: 'PDP_MEASUREMENT_ACCENT_WIDTH',
  ankle: 'PDP_MEASUREMENT_ANKLE',
  arm_length: 'PDP_MEASUREMENT_ARM_LENGTH',
  band_length: 'PDP_MEASUREMENT_BAND_LENGTH',
  band_width: 'PDP_MEASUREMENT_BAND_WIDTH',
  bib_width: 'PDP_MEASUREMENT_BIB_WIDTH',
  bottom_length: 'PDP_MEASUREMENT_BOTTOM_LENGTH',
  bracelet_length: 'PDP_MEASUREMENT_BRACELET_LENGTH',
  brim_width: 'PDP_MEASUREMENT_BRIM_WIDTH',
  bust: 'PDP_MEASUREMENT_BUST',
  chain_length: 'PDP_MEASUREMENT_CHAIN_LENGTH',
  circumference: 'PDP_MEASUREMENT_CIRCUMFERENCE',
  cuff_height: 'PDP_MEASUREMENT_CUFF_HEIGHT',
  depth: 'PDP_MEASUREMENT_DEPTH',
  diameter: 'PDP_MEASUREMENT_DIAMETER',
  frame_height: 'PDP_MEASUREMENT_FRAME_HEIGHT',
  frame_width: 'PDP_MEASUREMENT_FRAME_WIDTH',
  heel_height: 'PDP_MEASUREMENT_HEEL_HEIGHT',
  height: 'PDP_MEASUREMENT_HEIGHT',
  hip: 'PDP_MEASUREMENT_HIP',
  inner_inseam: 'PDP_MEASUREMENT_INNER_INSEAM',
  inner_thigh: 'PDP_MEASUREMENT_INNER_THIGH',
  inseam: 'PDP_MEASUREMENT_INSEAM',
  length: 'PDP_MEASUREMENT_LENGTH',
  length_handle: 'PDP_MEASUREMENT_LENGTH_HANDLE',
  length_strap: 'PDP_MEASUREMENT_LENGTH_STRAP',
  maximum_length: 'PDP_MEASUREMENT_MAXIMUM_LENGTH',
  minimum_length: 'PDP_MEASUREMENT_MINIMUM_LENGTH',
  outer_thigh: 'PDP_MEASUREMENT_OUTER_THIGH',
  pendant_length: 'PDP_MEASUREMENT_PENDANT_LENGTH',
  pendant_width: 'PDP_MEASUREMENT_PENDANT_WIDTH',
  platform_height: 'PDP_MEASUREMENT_PLATFORM_HEIGHT',
  sleeve_circumference: 'PDP_MEASUREMENT_SLEEVE_CIRCUMFERENCE',
  sleeve_length: 'PDP_MEASUREMENT_SLEEVE_LENGTH',
  thigh: 'PDP_MEASUREMENT_THIGH',
  top_length: 'PDP_MEASUREMENT_TOP_LENGTH',
  total_length: 'PDP_MEASUREMENT_TOTAL_LENGTH',
  under_bust: 'PDP_MEASUREMENT_UNDER_BUST',
  waist: 'PDP_MEASUREMENT_WAIST',
  width: 'PDP_MEASUREMENT_WIDTH',
  wrist: 'PDP_MEASUREMENT_WRIST',
}

const MEASUREMENT_TITLE_LOCIZE = {
  body: 'PDP_MEASUREMENT_TYPE_BODY',
  product: 'PDP_MEASUREMENT_TYPE_PRODUCT',
}

const MEASUREMENT_TYPE = {
  body: 'body',
  new_body: 'new_body',
  product: 'product',
  shoe: 'shoe',
}

const BASE_CELL_WIDTH = 40

const CONTENT_ROW_PADDING = 16 // left + right padding

export {
  BASE_CELL_WIDTH,
  BODY_PART_MEASUREMENT,
  CONTENT_ROW_PADDING,
  MEASUREMENT_DATA,
  MEASUREMENT_TITLE_LOCIZE,
  MEASUREMENT_TYPE,
}
